import { FC } from 'react';
import { RollingNumber } from '@mantine/core';
import { CountBadge } from '@srm/ui/count-badge';

interface NotificationBadgeProps {
    count: number;
}

const ANIMATION_MS = 400;
const MAX_VISIBLE_COUNT = 99;
const ANIMATION_TIMING_FUNCTION = 'cubic-bezier(0.22, 0.61, 0.36, 1)';

const NotificationBadge: FC<NotificationBadgeProps> = ({ count }) => {
    if (count <= 0) return null;

    return (
        <CountBadge className="notification-badge">
            <RollingNumber
                component="span"
                className="notification-badge__number"
                classNames={{ char: 'notification-badge__number-char' }}
                value={Math.min(count, MAX_VISIBLE_COUNT)}
                suffix={count > MAX_VISIBLE_COUNT ? '+' : undefined}
                animationDuration={ANIMATION_MS}
                timingFunction={ANIMATION_TIMING_FUNCTION}
            />
        </CountBadge>
    );
};

export default NotificationBadge;
